module.exports = {"days":"Days","hours":"Hrs","minutes":"Mins","seconds":"Secs"}